<script>
import { required } from 'vuelidate/lib/validators'

export default {
	props: {
		alert: {
			type: Object,
			required: true
		}
	},
	data() {
		return {

		}
	},
	methods: {
		formatSeverityText (severity) {
			let severityColor = {
				"high": "color:#FF6780",
				"medium": "color:#FFC60B",
				"low": "color:#4DD8A8"
			}
			return severityColor[severity]
		},
		formatTypeText (severity) {
			let severityColor = {
				"Malware": "color:#FF6780",
				"medium": "color:#FFC60B",
				"low": "color:#4DD8A8"
			}
			return severityColor[severity]
		},
		formatAction (action) {
			let actionColor = {
				"DETECTED": "color:rgb(26, 5, 214)",
				"BLOCKED_9": "color:#01AD00",
				"PREVENTED": "color:#01AD00"
			}
			return actionColor[action]
		}
	}
}
</script>

<template>
	<div>
		<div class="custom-control">
			<b>Name:</b>&nbsp;{{ alert.name }}
		</div> 
		<div class="custom-control">
			<b>Description:</b>&nbsp;{{ alert.description }}
		</div> 
		<template v-if="alert.severity === 'low'">
			<feather type="alert-circle" class="icon-dual-success icon-xs mr-2 align-middle"></feather>
		</template>
		<template v-else-if="alert.severity === 'medium'">
			<feather type="alert-triangle" class="icon-dual-warning icon-xs mr-2 align-middle"></feather>
		</template>
		<template v-else>
			<feather type="alert-octagon" class="icon-dual-danger icon-xs mr-2 align-middle"></feather>
		</template>
			<b>Severity:</b>&nbsp;<span :style="formatSeverityText(alert.severity)">{{ alert.severity }}</span>
		<template v-if="alert.category !== undefined && alert.category !== null">
			<div class="custom-control">
				<b>Category:</b>&nbsp;{{ alert.category }}
			</div> 
		</template>
		<template v-if="alert.source !== undefined && alert.source !== null">
			<div class="custom-control">
				<b>Source:</b>&nbsp;{{ alert.source }}
			</div>
		</template>
		<div class="custom-control">
			<b>Action:</b>&nbsp;<span :style="formatAction(alert.action)">{{ alert.action_pretty }}</span>
		</div> 
		<div class="custom-control">
			<b>ID:</b>&nbsp;{{ alert.alert_id }}
		</div> 
		<div class="custom-control">
			<b>Category:</b>&nbsp;<span :style="formatTypeText(alert.category)">{{ alert.category }}</span>
		</div> 
		<template v-if="alert.host_ip !== undefined && alert.host_ip !== null">
			<div class="custom-control">
				<b>Host IP:</b>&nbsp;{{ alert.host_ip }}
			</div> 
		</template>
		<template v-if="alert.host_name !== undefined && alert.host_name !== null">
			<div class="custom-control">
				<b>Hostname:</b>&nbsp;{{ alert.host_name }}
			</div> 
		</template>
		<template v-if="alert.user_name !== undefined && alert.user_name !== null">
			<div class="custom-control">
				<b>Username:</b>&nbsp;{{ alert.user_name }}
			</div> 
		</template>

		<template v-if="alert.action_file_sha256 !== undefined && alert.action_file_sha256 !== null">
			<div class="custom-control">
				<b>SHA265:</b>&nbsp;{{ alert.action_file_sha256 }}
			</div> 
		</template>
		<template v-if="alert.action_local_ip !== undefined && alert.action_local_ip !== null">
			<div class="custom-control">
				<b>Action Local IP:</b>&nbsp;{{ alert.action_local_ip }}
			</div> 
		</template>
		<template v-if="alert.action_local_port !== undefined && alert.action_local_port !== null">
			<div class="custom-control">
				<b>Action Local Port:</b>&nbsp;{{ alert.action_local_port }}
			</div> 
		</template>
		<template v-if="alert.action_remote_ip !== undefined && alert.action_remote_ip !== null">
			<div class="custom-control">
				<b>Action Remote IP:</b>&nbsp;{{ alert.action_remote_ip }}
			</div> 
		</template>
		<template v-if="alert.action_remote_port !== undefined && alert.action_remote_port !== null">
			<div class="custom-control">
				<b>Action Remote Port:</b>&nbsp;{{ alert.action_remote_port }}
			</div> 
		</template>
		<template v-if="alert.action_file_path !== undefined && alert.action_file_path !== null">
			<div class="custom-control">
				<b>File:</b>&nbsp;{{ alert.action_file_path }}
			</div> 
		</template>
	</div>
</template>

<style>
	.incident-status {
		width: 15%;
	}
	.incident-description {
		width: 35%;
	}
</style>